var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tenancy-view-info-wrapper" },
    [
      _c("div", { staticClass: "row main-content" }, [
        _c(
          "div",
          { staticClass: "basic-column" },
          [
            _c("div", { staticClass: "column-header" }, [
              _vm._v(
                "\n        " + _vm._s(_vm.$t("tenancy.basicInfo")) + "\n      "
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "contents" }, [
              _c(
                "div",
                { staticClass: "column-content" },
                [
                  _c("TextField", {
                    attrs: {
                      label: _vm.$t("tenancy.companyId"),
                      value: _vm.isDummyCompany
                        ? "--"
                        : _vm.deep(_vm.currentTenancy, "company.id"),
                      showColon: false,
                      readonly: true,
                    },
                  }),
                  _vm._v(" "),
                  _c("TextField", {
                    attrs: {
                      label: _vm.$t("tenancy.companyName"),
                      value: _vm.deep(_vm.currentTenancy, "company.name"),
                      showColon: false,
                      readonly: true,
                    },
                  }),
                  _vm._v(" "),
                  _c("TextField", {
                    attrs: {
                      label: _vm.$t("tenancy.tradeName"),
                      value: _vm.currentTenancy.tradeName || "--",
                      showColon: false,
                      readonly: true,
                    },
                  }),
                  _vm._v(" "),
                  _c("TextField", {
                    attrs: {
                      label: _vm.$t("tenancy.phoneNumber"),
                      value:
                        _vm.deep(_vm.currentTenancy, "company.phone") || "--",
                      showColon: false,
                      readonly: true,
                    },
                  }),
                  _vm._v(" "),
                  _c("TextField", {
                    attrs: {
                      label: _vm.$t("tenancy.alternativePhoneNumber"),
                      value:
                        _vm.deep(_vm.currentTenancy, "company.altPhone") ||
                        "--",
                      showColon: false,
                      readonly: true,
                    },
                  }),
                  _vm._v(" "),
                  _c("TextField", {
                    attrs: {
                      label: _vm.$t("tenancy.faxNumber"),
                      value:
                        _vm.deep(_vm.currentTenancy, "company.fax") || "--",
                      showColon: false,
                      readonly: true,
                    },
                  }),
                  _vm._v(" "),
                  _c("TextField", {
                    attrs: {
                      label: _vm.$t("tenancy.email"),
                      value:
                        _vm.deep(_vm.currentTenancy, "company.email") || "--",
                      showColon: false,
                      readonly: true,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "column-content column-content-right" },
                [
                  _vm.adminAccount && _vm.adminAccount.TenancyAccount
                    ? _c("div", { staticClass: "main-contacts" }, [
                        _c("label", [
                          _vm._v(_vm._s(_vm.$t("tenancy.mainContact"))),
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.displayI18nFullName(
                                _vm.adminAccount.TenancyAccount
                                  .contactFirstName,
                                _vm.adminAccount.TenancyAccount.contactLastName
                              )
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.adminAccount.TenancyAccount.phone
                          ? _c("p", [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.adminAccount.TenancyAccount.phone
                                  ) +
                                  "\n            "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.adminAccount.username
                          ? _c("p", { staticClass: "main-contact-username" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.adminAccount.username) +
                                  "\n            "
                              ),
                            ])
                          : _vm._e(),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.showHolidayHour
                    ? _c("div", { staticClass: "tenancy-working-hours" }, [
                        _c("label", [
                          _vm._v(_vm._s(_vm.$t("tenancy.workingHours"))),
                        ]),
                        _vm._v(" "),
                        _vm.regularOpeningHours.length
                          ? _c(
                              "ul",
                              { staticClass: "tenancy-working-hours-list" },
                              _vm._l(
                                _vm.regularOpeningHours,
                                function (item, index) {
                                  return _c("li", { key: index }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("customWorkingDayLabel")(
                                            item.workingDayFrom
                                          )
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    item.workingDayTo
                                      ? _c("span", [_vm._v(" - ")])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "u-margin-right-small" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("customWorkingDayLabel")(
                                              item.workingDayTo
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("customWorkingHourLabel")(
                                            item.workingHourFrom
                                          )
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    item.workingHourTo
                                      ? _c("span", [_vm._v(" - ")])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("customWorkingHourLabel")(
                                            item.workingHourTo
                                          )
                                        )
                                      ),
                                    ]),
                                  ])
                                }
                              ),
                              0
                            )
                          : _c("p", [
                              _vm._v("\n              --\n            "),
                            ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isOffice && _vm.canReadDir && _vm.enableDirectoryFeature
                    ? _c("div", { staticClass: "directory-link" }, [
                        _vm.showDirPin
                          ? _c("div", { staticClass: "pin-placeholder" }, [
                              _vm._m(0),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            on: {
                              click: function () {
                                return _vm.navToDirectory()
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("directory.requisition")))]
                        ),
                      ])
                    : _vm._e(),
                ]
              ),
            ]),
            _vm._v(" "),
            _vm.showHolidayHour ? _c("TenancyOpeningHour") : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "alarm-section" }, [
              _c("div", { staticClass: "fire-alarm-section" }, [
                _c("div", { staticClass: "alarm-section__label-btn" }, [
                  _c("label", [_vm._v(_vm._s(_vm.$t("tenancy.alarmSysHint")))]),
                ]),
                _vm._v(" "),
                _c("label", { staticClass: "emphasis alarm-label" }, [
                  _vm._v(_vm._s(_vm.$t("tenancy.fireAlarmSystem")) + ":"),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [{ name: "hkldinput", rawName: "v-hkldinput" }],
                  staticClass: "alarm-checkbox",
                  attrs: { type: "radio", name: "fireAlarm", disabled: true },
                  domProps: { checked: _vm.currentTenancy.isFireAlarm },
                }),
                _vm._v(" "),
                _c("label", { staticClass: "alarm-checkbox-label" }, [
                  _vm._v(_vm._s(_vm.$t("action.yes"))),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [{ name: "hkldinput", rawName: "v-hkldinput" }],
                  staticClass: "alarm-checkbox",
                  attrs: { type: "radio", name: "fireAlarm", disabled: true },
                  domProps: {
                    checked:
                      _vm.currentTenancy.isFireAlarm !== null &&
                      !_vm.currentTenancy.isFireAlarm,
                  },
                }),
                _vm._v(" "),
                _c("label", { staticClass: "alarm-checkbox-label" }, [
                  _vm._v(_vm._s(_vm.$t("action.no"))),
                ]),
              ]),
              _vm._v(" "),
              _c("div", [
                _c("label", { staticClass: "emphasis alarm-label" }, [
                  _vm._v(_vm._s(_vm.$t("tenancy.burglarAlarmSystem")) + ":"),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [{ name: "hkldinput", rawName: "v-hkldinput" }],
                  attrs: {
                    type: "radio",
                    name: "burglarAlarm",
                    disabled: true,
                  },
                  domProps: { checked: _vm.currentTenancy.isBurglarAlarm },
                }),
                _vm._v(" "),
                _c("label", { staticClass: "alarm-checkbox-label" }, [
                  _vm._v(_vm._s(_vm.$t("action.yes"))),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [{ name: "hkldinput", rawName: "v-hkldinput" }],
                  attrs: {
                    type: "radio",
                    name: "burglarAlarm",
                    disabled: true,
                  },
                  domProps: {
                    checked:
                      _vm.currentTenancy.isBurglarAlarm !== null &&
                      !_vm.currentTenancy.isBurglarAlarm,
                  },
                }),
                _vm._v(" "),
                _c("label", { staticClass: "alarm-checkbox-label" }, [
                  _vm._v(_vm._s(_vm.$t("action.no"))),
                ]),
              ]),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "contact-column" }, [
          _c("div", { staticClass: "column-header" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("tenancy.premisesInformation")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "contents" }, [
            _c(
              "div",
              { staticClass: "site-building-floor" },
              [
                _c("TextField", {
                  staticClass: "building",
                  attrs: {
                    label: _vm.$t("tenancy.building"),
                    value:
                      (_vm.currentTenancy.building &&
                        _vm.currentTenancy.building.code) ||
                      _vm.$t("emptyValue"),
                    showColon: false,
                    readonly: true,
                  },
                }),
                _vm._v(" "),
                _c("TextField", {
                  staticClass: "zone",
                  attrs: {
                    label: _vm.$t("tenancy.zone"),
                    value: _vm.zone,
                    showColon: false,
                    readonly: true,
                  },
                }),
                _vm._v(" "),
                _c("TextField", {
                  attrs: {
                    label: _vm.$t("tenancy.type"),
                    value: _vm.currentTenancyType,
                    showColon: false,
                    readonly: true,
                  },
                }),
                _vm._v(" "),
                _vm.isCurrentRegionHK
                  ? _c(
                      "div",
                      { staticClass: "ekey-info" },
                      [
                        !_vm.isTenant
                          ? _c("TextField", {
                              attrs: {
                                label: _vm.$t("tenancy.pm-t006"),
                                value:
                                  _vm.currentTenancy.eKey ||
                                  _vm.$t("emptyValue"),
                                showColon: false,
                                readonly: true,
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "premises-info" },
              [
                _c("TextField", {
                  attrs: {
                    label: _vm.$t("tenancy.premises"),
                    value: _vm.currentLeases || _vm.$t("emptyValue"),
                    showColon: false,
                    readonly: true,
                  },
                }),
                _vm._v(" "),
                _c(
                  "ul",
                  { staticClass: "premises-details" },
                  [
                    _c("li", { staticClass: "title" }, [
                      _c("span", { staticClass: "detail" }, [
                        _vm._v(_vm._s(_vm.$t("tenancy.premisesDetail"))),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "floor" }, [
                        _vm._v(_vm._s(_vm.$t("tenancy.floor"))),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "effective-date" }, [
                        _vm._v(_vm._s(_vm.$t("tenancy.effectiveDate"))),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "effective-date" }, [
                        _vm._v(_vm._s(_vm.$t("tenancy.endDate"))),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.premisesDetailList, function (info, index) {
                      return _c("li", { key: index }, [
                        _c("span", { staticClass: "detail" }, [
                          _vm._v(_vm._s(info.detail)),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "floor" }, [
                          _vm._v(_vm._s(info.floor)),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "effective-date" }, [
                          _vm._v(_vm._s(_vm.formatDate(info.effectiveDate))),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "effective-date" }, [
                          _vm._v(_vm._s(_vm.formatDate(info.endDate))),
                        ]),
                      ])
                    }),
                  ],
                  2
                ),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm.hasReadMoveInOutAccess
        ? _c("TenancyMoveInOut", {
            attrs: { tenancyId: _vm.tenancyId, hotbs: _vm.hotbs },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.enableTenantProjectsFeature
        ? _c(
            "div",
            { staticClass: "hotb-section" },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showCreateHoButton(),
                      expression: "showCreateHoButton()",
                    },
                  ],
                  staticClass: "hotb-btns rows",
                },
                [
                  _c(
                    "button",
                    {
                      directives: [
                        { name: "hkldreset", rawName: "v-hkldreset" },
                      ],
                      staticClass: "btn btn--orange",
                      attrs: { type: "button" },
                      on: {
                        click: function () {
                          return _vm.createHandover()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("action.new")) +
                          " " +
                          _vm._s(_vm.$t("tenancyProject.handover")) +
                          "\n      "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      directives: [
                        { name: "hkldreset", rawName: "v-hkldreset" },
                      ],
                      staticClass: "btn btn--darkblue",
                      attrs: { type: "button" },
                      on: {
                        click: function () {
                          return _vm.createTakeback()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("action.new")) +
                          " " +
                          _vm._s(_vm.$t("tenancyProject.takeback")) +
                          "\n      "
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _vm.showHoList()
                ? _c("HotbList", { attrs: { tenancyId: _vm.tenancyId } })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.canTenancyRecordRead ? _c("TenancyDocumentsVue") : _vm._e(),
      _vm._v(" "),
      _c(
        "modal",
        {
          ref: "alertModalForNewHandover",
          attrs: { modalId: "alert-modal-for-new-handover" },
        },
        [
          _c("div", { attrs: { slot: "content" }, slot: "content" }, [
            _c("p", { staticClass: "modal-pure-text" }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t("handover.noBuildingHint", [
                      _vm.missingType,
                      _vm.missingTips,
                    ])
                  ) +
                  "\n      "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
            _c(
              "button",
              {
                staticClass: "btn btn--orange",
                attrs: { type: "button" },
                on: {
                  click: function () {
                    return _vm.closeAlertModal()
                  },
                },
              },
              [_vm._v("\n        " + _vm._s(_vm.$t("hint.okay")) + "\n      ")]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pin__bubble-orange" }, [
      _c("i", {
        staticClass: "fa fa-thumb-tack",
        attrs: { "aria-hidden": "true" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }